import _ from 'lodash';

/**
 * A base action class for updating the customer profile
 * Extending classes must provide implementation of ```_update``` and `_getValidationErrors``` methods.
 */
export default class {
  constructor(context) {
    this.context = context;
  }

  run(attrs) {
    _.forEach(attrs, function(value, key) {
      if (typeof value === 'string') {
        attrs[key] = value.trim();
      }
    });
    let validationErrors = this._getValidationErrors(attrs);
    if (validationErrors.length) {
      this.context.stores.profile.setErrors(validationErrors);
    } else {
      let profile = this.context.stores.profile.get();
      if (!profile || !this.currentCustomerId) {
        return;
      }
      let updatedAttributes = this._update(profile, attrs);
      this.context.stores.profile.setPending(profile);
      this.context.gateways.customerProfile.update({ customerId: this.currentCustomerId }, updatedAttributes);
    }
  }

  get currentCustomerId() {
    return this.context.stores.currentLocation.get().customerId;
  }

  /**
   * Returns validation errors for the specified attributes.
   * @returns an array of Err objects or an empty array if there were no errors.
   *
   * Subclasses must provide an implementation.
   */
  _getValidationErrors(attrs) {
    throw new Error('_getValidationErrors not implemented');
  }

  /**
   * Updates the CustomerProfile with attributes and returns effectively updated attributes.
   * @returns an object containing effectively updated attributes for sending to the gateway.
   *
   * Subclasses must provide an implementation.
   */
  _update() {
    throw new Error('_update is not implemented');
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/update_profile_action_base.js